/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import DummyLink from '../../components/dummyLink';
import { HOMEPAGE, ROUTES } from '../../constants/routes.constants';
import { getConditions, getCookies, getManual, getPrivacy } from '../../services/config.service';
import { downloadPdf } from '../../utils/downloadUtils';
import { MANUAL_NAME, POLICY_NAMES } from '../../config';

/**
 * Componente que genera el footer
 *
 * @component
 * @returns {React.ReactElement}
 */
export default function Footer() {
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const [isAccesoAutorizado, setIsAccesoAutorizado] = useState(false);
  const [isPrivacy, setIsPrivacy] = useState(false);
  const [isConditions, setIsConditions] = useState(false);
  const [isCookies, setIsCookies] = useState(false);
  const [isManual, setIsManual] = useState(false);

  const getFooter = async () => {
    const privacyDoc = await getPrivacy();
    const conditionsDoc = await getConditions();
    const cookiesDoc = await getCookies();
    const manualDoc = await getManual();
    setIsPrivacy(!!privacyDoc?.data?.size);
    setIsConditions(!!conditionsDoc?.data?.size);
    setIsCookies(!!cookiesDoc?.data?.size);
    setIsManual(!!manualDoc?.data?.size);
    setLoaded(true);
  };
  useEffect(() => {
    setIsAccesoAutorizado(window.location.pathname.includes(ROUTES.ACCESO_AUTORIZADO));
    history.listen((location) => {
      setIsAccesoAutorizado(location.pathname === ROUTES.ACCESO_AUTORIZADO);
    });
    getFooter();
  }, []);

  const onClickPrivacidad = async () => {
    const { status, data: response } = await getPrivacy();
    if (status === 200) {
      await downloadPdf({ blob: response, fileName: POLICY_NAMES.PRIVACY });
    }
  };

  const onClickInformacion = async () => {
    const { status, data: response } = await getConditions();
    if (status === 200) {
      await downloadPdf({ blob: response, fileName: POLICY_NAMES.INFORMATION });
    }
  };

  const onClickCookies = async () => {
    const { status, data: response } = await getCookies();
    if (status === 200) {
      await downloadPdf({ blob: response, fileName: POLICY_NAMES.COOKIES });
    }
  };

  const onClickManual = async () => {
    const { status, data: response } = await getManual();
    if (status === 200) {
      await downloadPdf({ blob: response, fileName: MANUAL_NAME });
    }
  };

  const href = (route) => `${HOMEPAGE}${route}`;
  return (
    loaded && (
      <footer className="c-sii-footer">
        <ul className="c-sii-footer__list">
          {isConditions && (
            <li className="c-sii-footer__item">
              <DummyLink label="Política del sistema interno de información" onClick={onClickInformacion} />
            </li>
          )}
          {isPrivacy && (
            <li className="c-sii-footer__item">
              <DummyLink label="Política de Privacidad" onClick={onClickPrivacidad} />
            </li>
          )}
          {isCookies && (
            <li className="c-sii-footer__item">
              <DummyLink label="Política de Cookies" onClick={onClickCookies} />
            </li>
          )}
          {isManual && (
            <li className="c-sii-footer__item">
              <DummyLink label="Manual de usuario" onClick={onClickManual} />
            </li>
          )}
          <li className="c-sii-footer__item">
            <a className="sii-link" href={href(isAccesoAutorizado ? ROUTES.HOME : ROUTES.ACCESO_AUTORIZADO)}>
              {isAccesoAutorizado ? 'Página de inicio' : 'Acceso personal autorizado'}
            </a>
          </li>
        </ul>
      </footer>
    )
  );
}

Footer.propTypes = {};
